import Model from '@/store/plugins/orm/Model'
import Money from '@/wrappers/Money';
import Store from '@/store';
import i18n from '@/i18n';
import moment from 'moment-timezone';

export class ClientTransaction extends Model {
    static get entity () {
        return 'client_transactions'
    }

    static get TYPE_MANUAL() {
        return 'manual';
    }
    static get TYPE_AUTO() {
        return 'auto';
    }

    static get BASIS_SALE() {
        return 'sale';
    }
    static get BASIS_ORDER() {
        return 'order';
    }
    static get BASIS_SUMMARY() {
        return 'summary';
    }
    static get BASIS_REFUND() {
        return 'refund';
    }
    static get BASIS_ADVANCE() {
        return 'advance';
    }
    static get BASIS_CREDIT_NOTE() {
        return 'credit_note';
    }
    static get BASIS_PAYMENT() {
        return 'payment';
    }
    static get BASIS_WRITE_OFF() {
        return 'write_off';
    }
    static get BASIS_CLIENT_SALE() {
        return 'client_sale';
    }
    static get BASIS_CLIENT_ORDER() {
        return 'client_order';
    }
    static get BASIS_CLIENT_SUMMARY() {
        return 'client_summary';
    }
    static get BASIS_CLIENT_REFUND() {
        return 'client_refund';
    }
    static get BASIS_CLIENT_ADVANCE() {
        return 'client_advance';
    }
    static get BASIS_CLIENT_CREDIT_NOTE() {
        return 'client_credit_note';
    }
    static get BASIS_CLIENT_PAYMENT() {
        return 'client_payment';
    }
    static get BASIS_CLIENT_WRITE_OFF() {
        return 'client_write_off';
    }

    static fields () {
        return {
            id: this.attr(null),
            client_id: this.attr(null),
            order_id: this.attr(null),
            bank_statement_id: this.attr(null),
            number: this.attr(null),
            document_number: this.attr(null),
            type: this.attr(null),
            basis: this.attr(null),
            date: this.attr(null),
            due_date: this.attr(null),
            debt: this.attr('0.0000', value => _.round(value, 4).toFixed(4)),
            credit: this.attr('0.0000', value => _.round(value, 4).toFixed(4)),
            balance: this.attr('0.0000', value => _.round(value, 4).toFixed(4)),
            note: this.attr(null),
            confirmed: this.attr(true),

            client: this.attr(null),
        }
    }

    getDebt() {
        return Money.parse(this.debt);
    }

    getCredit() {
        return Money.parse(this.credit);
    }

    getBalance() {
        return Money.parse(this.balance);
    }

    static toTextLines(items = [], client, fromDate, toDate) {
        const venue = Store.getters.tenant?.venue;
        if(!venue) return [];

        const lines = [];

        lines.push(`[HR]`);
        lines.push(`[C][H22]${i18n.tc('client_transactions.heading', 1)}`);
        lines.push(`[HR]`);
        lines.push(`[L]`);
        lines.push(`[L]${i18n.tc('general.client', 1)}: ${client.name}[R]${venue.name}`);
        lines.push(`[L]${moment(fromDate).format('DD.MM.YYYY.')} - ${moment(toDate).format('DD.MM.YYYY.')}[R]${i18n.t('general.tax_id_number')}: ${venue.tax_id_number}`);
        lines.push(`[L]${i18n.t('client_transactions.balance')}: ${items[items.length - 1].getBalance().toFormat('0.00')}`);

        lines.push(`[L]`);
        lines.push(`[L]`);
        lines.push(`[L]`);
        lines.push(`[L]`);

        lines.push(`[HR]`);
        lines.push(
            `[L][H00]${i18n.t('general.number')} / ${i18n.t('general.date')}` +
            `[L]${i18n.t('client_transactions.due_date')}` +
            `[L]${i18n.t('client_transactions.basis.heading')}` +
            `[L]${i18n.t('client_transactions.document_number')}` +
            `[R]${i18n.t('client_transactions.debt')}` +
            `[R]${i18n.t('client_transactions.credit')}` +
            `[R]${i18n.t('client_transactions.balance')}`
        );
        lines.push(`[HR]`);

        items.forEach((item, index) => {
            lines.push(
                `[L][H00]${item.number} / ${item.date ? moment(item.date).format('DD.MM.YYYY') : ''}` +
                `[L]${item.due_date ? moment(item.due_date).format('DD.MM.YYYY') : ''}` +
                `[L]${i18n.t(`client_transactions.basis.${item.basis}`)}` +
                `[L]${item.document_number}` +
                `[R]${item.getDebt().toFormat('0.00')}` +
                `[R]${item.getCredit().toFormat('0.00')}` +
                `[R]${item.getBalance().toFormat('0.00')}`
            );
        })

        lines.push(`[HR]`);

        return lines;
    }
}

export default ClientTransaction
